import { useEffect, useState } from "react";
import { AlertTriangle, Paperclip } from "lucide-react";
import api from "@/lib/api";

// Zeigt vor dem Versand, ob das WP-Datenblatt mitgeht – Warnung, wenn es fehlt.
export function AttachmentPreview({ url, testid }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(url).then((r) => alive && setP(r.data)).catch(() => alive && setP(null));
    return () => { alive = false; };
  }, [url]);
  if (!p?.applicable) return null;
  if (p.missing_datasheet) {
    return (
      <div className="rounded-xl border border-amber-500/50 bg-amber-500/10 px-3 py-2.5 text-[12.5px] text-amber-100 flex gap-2" data-testid={`${testid}-missing`}>
        <AlertTriangle size={15} className="text-amber-300 shrink-0 mt-0.5" />
        <div>
          <b>Kein Datenblatt hinterlegt.</b>{" "}
          {p.heat_pump_found
            ? <>Für {p.heat_pump} fehlt das Datenblatt im Katalog – die Mail geht ohne Datenblatt raus.</>
            : <>Zu diesem Angebot wurde keine Wärmepumpe im Katalog gefunden – die Mail geht ohne Datenblatt raus.</>}
        </div>
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-zinc-800 bg-[#09090B] px-3 py-2 text-[12px] text-zinc-300" data-testid={`${testid}-ok`}>
      {p.datasheets.map((d, i) => (
        <div key={i} className="flex items-center gap-1.5">
          <Paperclip size={12} className="text-[#00E575]" /> Datenblatt geht mit: <span className="text-zinc-100 truncate">{d.name}</span>
        </div>
      ))}
    </div>
  );
}
